import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import actions from 'shared/actions';

export function SuccessImpl({ onLoad }) {
  React.useEffect(onLoad, []);
  return '';
}

SuccessImpl.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  onLoad: actions.staging.onLoad,
};

export default connect(null, mapDispatchToProps)(SuccessImpl);
